import { ReactNode } from 'react';
import { Typography } from '@material-ui/core';


interface IProps {
    children: ReactNode
}

let RegistrationLabel = ({ children }: IProps) => {
    return (
        <Typography variant="subtitle2">
            {children}
        </Typography>
    )
}

export default RegistrationLabel;